import { IconButton, Tooltip } from '@chronosphereio/chrono-ui';
import { MouseEventHandler, memo, ReactNode } from 'react';

interface ActionButtonProps {
  label: string;
  helpText: string;
  icon: ReactNode;
  size?: 'small' | 'medium';
  isDisabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

/**
 * Action button, extra div is needed so help text still shows on hover when disabled.
 */
export const ActionButton = memo(function ActionButton(props: ActionButtonProps) {
  const { label, isDisabled, helpText, icon, size = 'medium', onClick } = props;
  return (
    <Tooltip Content={helpText}>
      <div>
        <IconButton aria-label={label} disabled={isDisabled} onClick={onClick} size={size}>
          {icon}
        </IconButton>
      </div>
    </Tooltip>
  );
});
